import { Component } from '@angular/core';

@Component({
    selector: 'app-boletim-bloqueio-assinatura',
    templateUrl: './bloqueio-assinatura.component.html',
    styleUrls: ['./bloqueio-assinatura.component.css']
})

export class BoletimBloqueioAssinaturaComponent {
}
